import { render, staticRenderFns } from "./selectSurchargeTermsDialog.vue?vue&type=template&id=e1b7c488&"
import script from "./selectSurchargeTermsDialog.vue?vue&type=script&lang=js&"
export * from "./selectSurchargeTermsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1b7c488')) {
      api.createRecord('e1b7c488', component.options)
    } else {
      api.reload('e1b7c488', component.options)
    }
    module.hot.accept("./selectSurchargeTermsDialog.vue?vue&type=template&id=e1b7c488&", function () {
      api.rerender('e1b7c488', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/selectSurchargeTermsDialog.vue"
export default component.exports